module.exports = __webpack_public_path__ + "img/whish-cropped.f8cb446a.png";